<!-- MODAL HEADER -->
<div class="modal-header">
  <h3 class="modal-title">
    <strong>{{ mode === 'lock' ? 'Lock' : 'Unlock' }} Tags</strong>
  </h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<br>

<!-- WARNING BANNER -->
@if (warningMessage) {
<div class="warning-msg-class">
  <div class="inner"><strong>{{ warningMessage }}</strong></div>
</div>
}

<!-- MODAL BODY -->
<div class="row" [hidden]="minimise">
  <div class="col-md-12">
    <div class="table-scroll" style="padding-top: 0 !important;">
      <table class="main-table">
        <thead>
          <tr>
            <th class="sticky-col"></th>
            <th class="sticky-col">Warning</th>
            <th class="sticky-col">HO LEID</th>
            <th class="sticky-col">LEID</th>
            <th class="sticky-col">Tax Code</th>
            <th class="sticky-col">Reporting Period</th>
            <th class="sticky-col">ME Code</th>
          </tr>
        </thead>
        <tbody>
          @for (t of lockUnlockSelected; track $index) {
<tr>
            <td>
              <i class="fa fa-times" style="cursor: pointer;" title="Remove Row"
                 (click)="removeLockUnLockRow(t)"></i>
            </td>
            <td [ngClass]="{
                  'warning-class': (mode === 'lock' && t.STATUS_FLAG === 'Locked') || (mode === 'unlock' && t.STATUS_FLAG === 'Unlocked'),
                  'default-color': (mode === 'lock' && t.STATUS_FLAG !== 'Locked') || (mode === 'unlock' && t.STATUS_FLAG !== 'Unlocked')
                }">
              @if (mode === 'lock' && t.STATUS_FLAG === 'Locked') {
<span>Already Locked</span>
}
              @if (mode === 'unlock' && t.STATUS_FLAG === 'Unlocked') {
<span>Already Unlocked</span>
}
            </td>
            <td>{{ t.HO_LEID }}</td>
            <td>{{ t.LEID }}</td>
            <td>{{ t.CDR_NO }}</td>
            <td>{{ t.REPORTING_PERIOD }}</td>
            <td>{{ t.ME_CODE }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL FOOTER -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button"
          [disabled]="warningExists || isSaveClicked"
          (click)="save()">
    Save
  </button>
  <button class="btn btn-warning btn-sm" type="button"
          (click)="cancel()">
    Cancel
  </button>
</div>
